<form #currentForm="ngForm">
  <tabset>
    <tab heading="Profile">
      <div class="py-2"></div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group" *ngIf="currentUserGroups.priviledged">
            <label>First Name</label>
            <input name="first_name" [(ngModel)]="person.first_name" type="text" class="form-control" />
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged">
            <label>Last Name</label>
            <input name="last_name" [(ngModel)]="person.last_name" type="text" class="form-control" />
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged">
            <label>Login</label>
            <input name="login" [(ngModel)]="user.login" type="text" class="form-control" />
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged">
            <label>Address for Email</label>
            <input name="email" type="email" [(ngModel)]="user.email" class="form-control" />
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged">
            <label>Gender</label>
            <select name="gender" [(ngModel)]="person.gender" class="form-control">
              <option value="m">Male</option>
              <option value="f">Female</option>
            </select>
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged || currentUserId == userId">
            <label>Unique Password</label>
            <input name="password" [(ngModel)]="user.password" type="password" class="form-control" />
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged || currentUserId == userId">
            <label>Password Confirmation</label>
            <input name="password_confirmation" [(ngModel)]="user.password_confirmation" type="password" class="form-control" />
          </div>
          <div class="form-group" *ngIf="userId && (currentUserGroups.priviledged || currentUserId == userId)">
            <div>
              <label>API key:&nbsp;{{ user.api_key }}</label>
              &nbsp;
              <app-clipboard-btn [cssClassBtn]="'btn btn-sm btn-outline-dark'" *ngIf="user.api_key" [errorNotificationMessage]="'Error copying API key'" [content]="user.api_key" [successNotificationMessage]="'API key copied'" [title]="'Copy API key'"></app-clipboard-btn>
            </div>
            <button [disabled]="creatingNewApiKey" (click)="newApiKey()" type="button" class="btn btn-sm btn-outline-dark">
              <span *ngIf="!creatingNewApiKey">New API key</span>
              <span *ngIf="creatingNewApiKey">
                Generating API key&nbsp;
                <i class="fas fa-spinner fa-fw fa-pulse"></i>
              </span>
            </button>
          </div>
          <div class="form-group" *ngIf="currentUserId == userId">
            <label>Browser Notifications</label>
            <br />
            <label>
              <b>Permission:&nbsp;</b>
              <app-badge badgeType="success" *ngIf="browserNotificationService.notificationPermissionGranted">
                Granted
              </app-badge>
              <app-badge badgeType="danger" *ngIf="!browserNotificationService.notificationPermissionGranted">
                Denied
              </app-badge>
            </label>
            <span *ngIf="!browserNotificationService.notificationPermissionGranted">
              &nbsp;
              <button type="button" class="btn btn-primary" (click)="browserNotificationService.requestNofiticationPermission()">Grant Permission</button>
            </span>
            <small *ngIf="!browserNotificationService.notificationPermissionGranted && browserNotificationService.notificationRequestDenied" class="text-muted form-text">{{ browserNotificationService.instructionsOnPermissionDenied }}</small>
          </div>
          <div class="form-group" title="For reminders and other such notifications" *ngIf="userId && (currentUserGroups.priviledged || currentUserId == userId)">
            <div class="custom-control custom-checkbox" (click)="user.allow_phone_text = !user.allow_phone_text">
              <input type="checkbox" class="custom-control-input" name="allow_phone_text" [(ngModel)]="user.allow_phone_text" />
              <label class="custom-control-label">Allow Phone Text</label>
            </div>
          </div>
          <div class="form-group" *ngIf="currentUserGroups.superuser">
            <label>Intranet</label>
            <select class="form-control" name="intranet_id" [(ngModel)]="user.intranet_id">
              <option *ngFor="let intranet of formOptions.intranets" [value]="intranet.value">{{ intranet.label }}</option>
            </select>
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged">
            <label>Group Membership (cmd-click) to select multiples</label>
            <select name="group_ids" [(ngModel)]="user.group_ids" class="form-control" multiple="multiple" size="4">
              <option *ngFor="let group of formOptions.groups" [value]="group.value">{{ group.label }}</option>
            </select>
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged">
            <label>Attorney Number</label>
            <input name="attorney_number" [(ngModel)]="user.attorney_number" type="text" class="form-control" />
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged">
            <label>Admittance Date</label>
            <input type="text" class="form-control" bsDatepicker [bsConfig]="{ containerClass: 'theme-dark-blue' }" name="admittance_date" [(ngModel)]="user.admittance_date" />
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged">
            <label>Manager</label>
            <select class="form-control" name="parent_id" [(ngModel)]="user.parent_id">
              <option *ngFor="let manager of formOptions.managers" [value]="manager.value">{{ manager.label }}</option>
            </select>
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged">
            <label>Extension</label>
            <input name="extension" [(ngModel)]="user.extension" type="text" class="form-control" />
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged && user.is_attorney">
            <label>Letterhead Position</label>
            <input name="letter_head_position" [(ngModel)]="user.letter_head_position" type="number" class="form-control" />
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged && user.is_attorney">
            <div class="custom-control custom-checkbox" (click)="user.of_counsel = !user.of_counsel">
              <input type="checkbox" class="custom-control-input" name="of_counsel" [(ngModel)]="user.of_counsel" />
              <label class="custom-control-label">Of Counsel</label>
            </div>
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged && user.is_attorney">
            <div class="custom-control custom-checkbox" (click)="user.include_in_letterhead = !user.include_in_letterhead">
              <input type="checkbox" class="custom-control-input" name="include_in_letterhead" [(ngModel)]="user.include_in_letterhead" />
              <label class="custom-control-label">Include in letterhead</label>
            </div>
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged">
            <div class="custom-control custom-checkbox" (click)="user.is_active = !user.is_active">
              <input type="checkbox" class="custom-control-input" name="is_active" [(ngModel)]="user.is_active" />
              <label class="custom-control-label">Active?</label>
            </div>
          </div>
        </div>
        <div class="col-md-6" *ngIf="currentUserGroups.priviledged || currentUserId == userId">
          <div class="form-group">
            <label>How many recent matters should show?</label>
            <input type="number" class="form-control" name="number_of_recents" [(ngModel)]="user.number_of_recents" />
          </div>
          <div class="form-group">
            <label>How many frequently visited matters should show?</label>
            <input type="number" class="form-control" name="number_of_favorites" [(ngModel)]="user.number_of_favorites" />
          </div>
          <div class="form-group">
            <label>Default to which history type?</label>
            <select class="form-control" name="matter_history_type_id" [(ngModel)]="user.matter_history_type_id">
              <option *ngFor="let matterHistoryType of formOptions.matter_history_types" [value]="matterHistoryType.value">{{ matterHistoryType.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>How many days of events on the home page?</label>
            <input type="number" class="form-control" name="event_days" [(ngModel)]="user.event_days" />
          </div>
          <div class="form-group">
            <label>How many entries should show?</label>
            <input type="number" class="form-control" name="number_of_entries" [(ngModel)]="user.number_of_entries" />
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox" (click)="user.show_billing_summary = !user.show_billing_summary">
              <input type="checkbox" class="custom-control-input" name="show_billing_summary" [(ngModel)]="user.show_billing_summary" />
              <label class="custom-control-label">Show the billing summary?</label>
            </div>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input id="receive_document_notifications_by_email" type="checkbox" class="custom-control-input" name="receive_document_notifications_by_email" [(ngModel)]="user.receive_document_notifications_by_email" />
              <label class="custom-control-label" for="receive_document_notifications_by_email">Receive document notifications by email</label>
            </div>
            <small class="form-text text-muted">When cleared, new documents still appear in the Document Inbox, but V7 does not send this user document-arrival emails.</small>
          </div>
          <div class="form-group">
            <label>Default Calendar Agenda</label>
            <select class="form-control" name="default_calendar_agenda" [(ngModel)]="user.default_calendar_agenda">
              <option *ngFor="let calendarAgenda of formOptions.calendar_agendas" [value]="calendarAgenda.value">{{ calendarAgenda.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Time Zone</label>
            <select class="form-control" name="time_zone" [(ngModel)]="user.time_zone">
              <option *ngFor="let timeZone of formOptions.time_zones" [value]="timeZone.value">{{ timeZone.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>What is the user's AVVO URL?</label>
            <input type="text" class="form-control" name="avvo_url" [(ngModel)]="user.avvo_url" />
          </div>
          <div class="form-group" *ngIf="currentUserGroups.priviledged">
            <label>Notes</label>
            <textarea class="form-control" name="notes" [(ngModel)]="user.notes"></textarea>
          </div>
          <div class="form-group">
            <label>Color Code</label>
            <input type="color" [disabled]="!currentUserGroups.priviledged" class="form-control" name="color_code" [(ngModel)]="user.color_code" />
          </div>
          <div class="form-group">
            <label>Weather Radar Location</label>
            <small class="form-text text-muted mb-2">Set coordinates for the weather radar on your dashboard. Leave blank to use your primary address.</small>
            <div class="row">
              <div class="col-6">
                <input type="number" step="0.000001" class="form-control" name="latitude" [(ngModel)]="user.latitude" placeholder="Latitude (e.g. 40.40)" />
              </div>
              <div class="col-6">
                <input type="number" step="0.000001" class="form-control" name="longitude" [(ngModel)]="user.longitude" placeholder="Longitude (e.g. -75.59)" />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox" (click)="user.to_do_visibility = !user.to_do_visibility">
              <input type="checkbox" class="custom-control-input" name="to_do_visibility" [(ngModel)]="user.to_do_visibility" />
              <label class="custom-control-label">To-Do Visibility</label>
            </div>
          </div>
          <div class="form-group" *ngIf="userId">
            <label>Signature Upload</label>
            <div>
              <input type="file" #signatureFileInput accept="image/png" (change)="onSignatureFileSelected($event)" style="display: none;" />
              <button type="button" class="btn btn-outline-primary" [disabled]="uploadingSignature || !user.matter_id" (click)="signatureFileInput.click()">
                <i class="fas fa-upload"></i> Upload Signature (PNG)
              </button>
              <div *ngIf="!user.matter_id" class="text-danger small mt-1">
                User must have an associated matter to upload signature
              </div>
            </div>
            <small class="form-text text-muted">
              Upload a PNG image to use as your signature. Previous signature will be archived.
            </small>
            <div *ngIf="uploadingSignature" class="mt-2">
              <i class="fas fa-spinner fa-fw fa-pulse"></i> Uploading signature...
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <button type="button" [disabled]="saving" class="btn btn-primary btn-block" (click)="save(currentForm)">
            <span *ngIf="!saving">Save</span>
            <span *ngIf="saving">
              Saving&nbsp;
              <i class="fas fa-spinner fa-fw fa-pulse"></i>
            </span>
          </button>
        </div>
        <div class="col-6">
          <button type="button" [disabled]="saving" class="btn btn-outline-secondary btn-block" (click)="back()">Cancel</button>
        </div>
      </div>
    </tab>
    <tab heading="2 Factor Auth">
      <div class="py-2"></div>
      <small class="text-muted font-italic">In Beta - being tested</small>
      <br /><br />
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <app-form-checkbox
              label="Enable 2 factor auth"
              helpText="2 factor authentication code can be received on both email and/or phone"
              [(model)]="otpSettings.otp_required_for_login"
              (change)="otpEnablementUpdated($event)"
            >
            </app-form-checkbox>
          </div>
        </div>
      </div>
      <div *ngIf='otpSettings.otp_required_for_login'>
        <div class="row">
          <div class="col-md-6">
            <app-form-text-input 
              [customLabel]='true'
              [disabled]="!otpSettings.otp_send_to_email || otpSettings.otp_use_contact_email"
              helpText="Email to receive auth code"
              [(model)]="otpSettings.otp_email"
            >
              Email&nbsp;
              <app-badge badgeType="success" *ngIf="otpSettings.otp_send_to_email">
                Enabled
              </app-badge>
              <app-badge badgeType="secondary" *ngIf="!otpSettings.otp_send_to_email">
                Disabled
              </app-badge>
            </app-form-text-input>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <app-form-checkbox
                label="Send auth code to email"
                [(model)]="otpSettings.otp_send_to_email"
              >
              </app-form-checkbox>
              <app-form-checkbox
                label="Use my contact email"
                [(model)]="otpSettings.otp_use_contact_email"
                (change)="otpContactEmailUseChange($event)"
              >
              </app-form-checkbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <app-form-text-input 
              [customLabel]='true'
              [disabled]="!otpSettings.otp_send_to_phone || otpSettings.otp_use_contact_phone"
              helpText="Phone number to receive auth code"
              [(model)]="otpSettings.otp_phone"
            >
            Phone No.&nbsp;
            <app-badge badgeType="success" *ngIf="otpSettings.otp_send_to_phone">
              Enabled
            </app-badge>
            <app-badge badgeType="secondary" *ngIf="!otpSettings.otp_send_to_phone">
              Disabled
            </app-badge>
          </app-form-text-input>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <app-form-checkbox
                label="Send auth code to phone"
                [(model)]="otpSettings.otp_send_to_phone"
              >
              </app-form-checkbox>
              <app-form-checkbox
                label="Use my contact phone"
                [(model)]="otpSettings.otp_use_contact_phone"
                (change)="otpContactPhoneUseChange($event)"
              >
              </app-form-checkbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label>
              Element&nbsp;
              <app-badge badgeType="success" *ngIf="otpSettings.otp_send_to_element">
                Enabled
              </app-badge>
              <app-badge badgeType="secondary" *ngIf="!otpSettings.otp_send_to_element">
                Disabled
              </app-badge>
            </label>
            <app-form-checkbox
              label="Send auth code to element"
              [(model)]="otpSettings.otp_send_to_element"
            >
            </app-form-checkbox>
          </div>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <button type="button" [disabled]="updatingOtpSettings" class="btn btn-primary btn-block" (click)="saveOtpSettings()">
            <span *ngIf="!updatingOtpSettings">Save</span>
            <span *ngIf="updatingOtpSettings">
              Saving&nbsp;
              <i class="fas fa-spinner fa-fw fa-pulse"></i>
            </span>
          </button>
        </div>
        <div class="col-md-4"></div>
      </div>
    </tab>
    <tab heading="Payroll" *ngIf="currentUserGroups.priviledged">
      <div class="py-2"></div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Contact Id</label>
            <app-contact-search [contactId]="user.person_id" (contact_id)="user.person_id = $event"></app-contact-search>
          </div>
          <div class="form-group">
            <label>Matter Id</label>
            <app-matter-search [matterId]="user.matter_id" (matter_id)="user.matter_id = $event"></app-matter-search>
          </div>
          <div class="form-group">
            <label>Personnel Matter Id</label>
            <app-matter-search [matterId]="user.personnel_id" (matter_id)="user.personnel_id = $event"></app-matter-search>
          </div>
          <div class="form-group">
            <label>Start Date</label>
            <input type="text" class="form-control" bsDatepicker [bsConfig]="{ containerClass: 'theme-dark-blue' }" name="start_date" [(ngModel)]="user.start_date" />
          </div>
          <div class="form-group">
            <label>Terminated On</label>
            <input type="text" class="form-control" bsDatepicker [bsConfig]="{ containerClass: 'theme-dark-blue' }" name="terminated_on" [(ngModel)]="user.terminated_on" />
          </div>
          <div class="form-group">
            <label>Termination Reason</label>
            <select class="form-control" name="termination_reason_id" [(ngModel)]="user.termination_reason_id">
              <option style="font-family: 'Roboto Mono', monospace" *ngFor="let terminationReason of formOptions.termination_reasons" [value]="terminationReason.value"><span [innerHTML]="terminationReason.label"></span></option>
            </select>
          </div>
          <div class="form-group">
            <label>Rehired On</label>
            <input type="text" class="form-control" bsDatepicker [bsConfig]="{ containerClass: 'theme-dark-blue' }" name="rehired_on" [(ngModel)]="user.rehired_on" />
          </div>
          <div class="form-group">
            <label>Chart of Account</label>
            <select class="form-control" name="chart_of_account_id" [(ngModel)]="user.chart_of_account_id">
              <option *ngFor="let chartOfAccount of formOptions.chart_of_accounts" [value]="chartOfAccount.value">{{ chartOfAccount.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Hourly Rate</label>
            <input type="number" class="form-control" name="hourly_rate" [(ngModel)]="user.hourly_rate" />
          </div>
          <div class="form-group">
            <label>Hours</label>
            <input type="number" class="form-control" name="hours" [(ngModel)]="user.hours" />
          </div>
          <div class="form-group">
            <label>Dependants</label>
            <input type="number" class="form-control" name="dependants" [(ngModel)]="user.dependants" />
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox" (click)="user.is_married = !user.is_married">
              <input type="checkbox" class="custom-control-input" name="is_married" [(ngModel)]="user.is_married" />
              <label class="custom-control-label">Is Married?</label>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Local EIT</label>
            <input type="number" class="form-control" name="eit" [(ngModel)]="user.eit" />
          </div>
          <div class="form-group">
            <label>Pension Percent</label>
            <div class="input-group mb-3">
              <input type="number" class="form-control" name="pension_percent" [(ngModel)]="user.pension_percent" />
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Roth IRA Percent</label>
            <div class="input-group mb-3">
              <input type="number" class="form-control" name="roth_ira_percent" [(ngModel)]="user.roth_ira_percent" />
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Factor Percent Per Payroll</label>
            <div class="input-group mb-3">
              <input type="number" class="form-control" name="factor_percent" [(ngModel)]="user.factor_percent" />
              <div class="input-group-append">
                <span class="input-group-text">%</span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Health Premium Per Pay</label>
            <input type="text" class="form-control" name="health_premium_per_pay" [(ngModel)]="user.health_premium_per_pay" />
          </div>
          <div class="form-group">
            <label>Health Premium Per Month</label>
            <input type="text" class="form-control" name="health_premium_per_month" [(ngModel)]="user.health_premium_per_month" />
          </div>
          <div class="form-group">
            <label>Health Cost Per Pay</label>
            <input type="text" class="form-control" name="health_cost_per_pay" [(ngModel)]="user.health_cost_per_pay" />
          </div>
          <div class="form-group">
            <label>Health Cost Per Month</label>
            <input type="text" class="form-control" name="health_cost_per_month" [(ngModel)]="user.health_cost_per_month" />
          </div>
          <div class="form-group">
            <label>Health Savings</label>
            <input type="text" class="form-control" name="health_savings" [(ngModel)]="user.health_savings" />
          </div>
          <div class="form-group">
            <label>Health Flex</label>
            <input type="text" class="form-control" name="health_flex" [(ngModel)]="user.health_flex" />
          </div>
          <div class="form-group">
            <label>Life Insurance Cost</label>
            <input type="text" class="form-control" name="life_cost" [(ngModel)]="user.life_cost" />
          </div>
          <div class="form-group">
            <label>Day Starts At</label>
            <input type="text" class="form-control" placeholder="09:00" name="start_at" [(ngModel)]="fields.start_at" />
          </div>
          <div class="form-group">
            <label>Day Ends At</label>
            <input type="text" class="form-control" placeholder="17:00" name="end_at" [(ngModel)]="fields.end_at" />
          </div>
          <div class="form-group">
            <label>Length of Lunch Break</label>
            <input type="text" class="form-control" placeholder="0" name="lunch" [(ngModel)]="fields.lunch" />
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox" (click)="fields.is_full_time = !fields.is_full_time">
              <input type="checkbox" class="custom-control-input" name="is_full_time" [(ngModel)]="fields.is_full_time" />
              <label class="custom-control-label">Is a full time employee? </label>
            </div>
          </div>
          <div class="form-group" (click)="user.is_other_comp = !user.is_other_comp">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" name="is_other_comp" [(ngModel)]="user.is_other_comp" />
              <label class="custom-control-label">Other Comp - Apply health cost to WIT? </label>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <button type="button" [disabled]="saving" class="btn btn-primary btn-block" (click)="save(currentForm)">
            <span *ngIf="!saving">Save</span>
            <span *ngIf="saving">
              Saving&nbsp;
              <i class="fas fa-spinner fa-fw fa-pulse"></i>
            </span>
          </button>
        </div>
        <div class="col-6">
          <button type="button" [disabled]="saving" class="btn btn-outline-secondary btn-block" (click)="back()">Cancel</button>
        </div>
      </div>
    </tab>
    <tab heading="Wage Base" *ngIf="currentUserGroups.admin && userId">
      <div class="py-3"></div>
      <app-wage-base-index [userId]="userId"></app-wage-base-index>
      <div class="py-3"></div>
    </tab>
    <tab heading="Contact" (selectTab)="openLink('/contacts/' + user.person_id)" *ngIf="user.person_id && (currentUserGroups.priviledged || currentUserId == userId)"> </tab>
    <tab heading="Matter" (selectTab)="openLink('/matters/' + user.matter_id)" *ngIf="user.matter_id && (currentUserGroups.priviledged || currentUserId == userId)"> </tab>
    <tab heading="Personnel Matter" (selectTab)="openLink('/matters/' + user.personnel_id)" *ngIf="currentUserGroups.priviledged && user.personnel_id"> </tab>
    <tab heading="Phone Calls">
      <app-phonecalls-index [extension]="user.extension" [minimalMode]="true"></app-phonecalls-index>
    </tab>
  </tabset>
</form>
